import React, { useState } from 'react';
import { TiChevronLeft, TiChevronRight } from 'react-icons/ti';

export const TwoContainerComponent = ({ leftComponent, rightComponent }) => {
	const [isOpen, setIsOpen] = useState(true);

	return (
		<div className='flex w-full h-full relative rounded-md'>
			{/* Contenedor izquierdo */}
			<div
				className={`flex flex-col h-full bg-white border drop-shadow-2xl rounded-md transition-all duration-300 ${
					isOpen ? 'w-64 sm:!w-28 md:!w-36 lg:!w-44 xl:!w-48' : 'w-16'
				} flex-none`}>
				<div className='flex justify-end p-1'>
					{isOpen ? (
						<TiChevronLeft
							onClick={() => setIsOpen(false)}
							className='text-2xl cursor-pointer text-gray-500'
						/>
					) : (
						<TiChevronRight
							onClick={() => setIsOpen(true)}
							className='text-2xl cursor-pointer text-gray-500'
						/>
					)}
				</div>
				{isOpen && <div className='flex w-full h-full'>{leftComponent}</div>}
			</div>

			{/* Contenedor derecho */}
			<div className='flex flex-grow h-full flex-col'>{rightComponent}</div>
		</div>
	);
};
